import avatar7 from "assets/images/users/avatar-7.jpg";
import avatar1 from "assets/images/users/avatar-1.jpg";
import avatar2 from "assets/images/users/avatar-2.jpg";
import avatar8 from "assets/images/users/avatar-8.jpg";

export const aboutCard = [
    {
        id: 1,
        title: '25,000+ Happy Customer',
        discription: "Customer happiness goes beyond customer satisfaction by creating an emotional connection with a brand's."
    },
    {
        id: 2,
        title: '6+ Years of Experiences',
        discription: "The years of experience you list on your resume represent the work experience you have if you have little experience."
    },
    {
        id: 3,
        title: '14 Awards Won',
        discription: "The Global Content Awards celebrate excellence in content marketing and rewards agencies and in-house teams."
    },
]

export const aboutManagement = [
    {
        id: 1,
        img: avatar7,
        title: "Rachael Larson",
        text: "Founder"
    },
    {
        id: 2,
        img: avatar1,
        title: "Jennifer Thompson",
        text: "Sr. Manager"
    },
    {
        id: 3,
        img: avatar2,
        title: "Amanda Rivera",
        text: "Marketing Executive"
    }, {
        id: 4,
        img: avatar8,
        title: "Donald Schmidt",
        text: "Account Executive"
    },
]

export const Location = [
    {
        id: 1,
        country: "Russia",
        Address: "Brusneva Ul., bld. 8, appt. 34, Stavropol, Russia"
    },
    {
        id: 2,
        country: "Israel",
        Address: "122 Maplewood Ave Toronto Ontario M6C1J6,Lod, Israel"
    },
    {
        id: 3,
        country: "Germany",
        Address: "Untersbergstraße 26, 81539 München, Germany"
    },
    {
        id: 4,
        country: "Colombia",
        Address: "Cl 33 No. 31-18, C.P 76520, Palmira, Colombia"
    },

]

export const storeLocation = [
    {
        id: 1,
        name: "FionaZiya -  Main Branch",
        location: "Russia",
        Email: "info@fionaziya.com",
        contactNo: "+(234) 12345 67890"
    },
    {
        id: 2,
        name: "FionaZiya",
        location: "Israel",
        Email: "example@FionaZiya.in",
        contactNo: "+(741) 65432 19870"
    },
    {
        id: 3,
        name: "FionaZiya",
        location: "Germany",
        Email: "example@Toner.com",
        contactNo: "+(365) 98765 43210"
    },
    {
        id: 4,
        name: "Skote",
        location: "Colombia",
        Email: "example@FionaZiya.com",
        contactNo: "+(137) 34567 89012"
    },
]

export const invioceRecod = [
    {
        id: 1,
        product: "World's most expensive t shirt",
        details: "Graphic Print Men Women Sweatshirt",
        rate: "266.24",
        quantity: "03",
        amount: "798.72"
    },
    {
        id: 2,
        product: "Ninja Pro Max Smartwatch",
        details: "large display of 40mm (1.6″ inch), 27 sports mode, SpO2 monitor",
        rate: "247.27",
        quantity: "01",
        amount: "247.27"
    },
    {
        id: 3,
        product: "Girls Mint Green Off-White Open Toe Flats",
        details: "Fabric:Synthetic · Color:Green · Shoe Type:Sandals",
        rate: "24.07",
        quantity: "05",
        amount: "120.35"
    },
    {
        id: 4,
        product: "Carven Lounge Chair Red",
        details: "Carven Fabric Lounge Chair in Red Color",
        rate: "209.99",
        quantity: "01",
        amount: "209.99"
    },

]